import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Button } from './ui/button';
import { FileCheck } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CedulaRCModal = () => {
  const { setUser } = useAuth();
  const [form, setForm] = useState({
    cedula_inicio: '',
    cedula_vencimiento: '',
    rc_inicio: '',
    rc_vencimiento: '',
  });
  const [loading, setLoading] = useState(false);

  const canSubmit = form.cedula_vencimiento && form.rc_vencimiento;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    setLoading(true);
    try {
      const payload = {
        cedula_vencimiento: form.cedula_vencimiento,
        rc_vencimiento:     form.rc_vencimiento,
        cedula_inicio:      form.cedula_inicio || null,
        rc_inicio:          form.rc_inicio     || null,
      };
      const { data } = await axios.put(`${API}/users/me/cedula-rc`, payload);
      setUser(prev => ({
        ...prev,
        cedula_inicio:      data.cedula_inicio,
        cedula_vencimiento: data.cedula_vencimiento,
        rc_inicio:          data.rc_inicio,
        rc_vencimiento:     data.rc_vencimiento,
      }));
      toast.success('Perfil profesional actualizado. Bienvenido al CRM.');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al guardar. Verifica las fechas.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
      <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-full max-w-md p-8 mx-4">
        <div className="flex flex-col items-center mb-6">
          <div className="p-4 rounded-full bg-[#1a365d] text-white mb-4">
            <FileCheck className="h-8 w-8" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white text-center">
            Completa tu perfil profesional
          </h2>
          <p className="text-sm text-gray-500 dark:text-gray-400 text-center mt-2">
            Para acceder al CRM necesitas registrar la vigencia de tu cédula profesional y póliza RC.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="border rounded-lg p-4 space-y-3">
            <p className="text-sm font-semibold text-gray-700 dark:text-gray-300">Cédula profesional</p>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1">
                <Label className="text-xs">Fecha de inicio</Label>
                <Input
                  type="date"
                  value={form.cedula_inicio}
                  onChange={e => setForm(f => ({ ...f, cedula_inicio: e.target.value }))}
                />
              </div>
              <div className="space-y-1">
                <Label className="text-xs">Vencimiento <span className="text-red-500">*</span></Label>
                <Input
                  type="date"
                  value={form.cedula_vencimiento}
                  onChange={e => setForm(f => ({ ...f, cedula_vencimiento: e.target.value }))}
                  required
                />
              </div>
            </div>
          </div>

          <div className="border rounded-lg p-4 space-y-3">
            <p className="text-sm font-semibold text-gray-700 dark:text-gray-300">Póliza RC</p>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1">
                <Label className="text-xs">Fecha de inicio</Label>
                <Input
                  type="date"
                  value={form.rc_inicio}
                  onChange={e => setForm(f => ({ ...f, rc_inicio: e.target.value }))}
                />
              </div>
              <div className="space-y-1">
                <Label className="text-xs">Vencimiento <span className="text-red-500">*</span></Label>
                <Input
                  type="date"
                  value={form.rc_vencimiento}
                  onChange={e => setForm(f => ({ ...f, rc_vencimiento: e.target.value }))}
                  required
                />
              </div>
            </div>
          </div>

          <Button
            type="submit"
            className="w-full bg-[#1a365d] hover:bg-[#1a365d]/90"
            disabled={loading || !canSubmit}
          >
            {loading ? 'Guardando...' : 'Guardar y continuar'}
          </Button>
        </form>
      </div>
    </div>
  );
};
